<template lang="html">
    <div class="table-wrap groundwater-level-table">

        <scrolling-table class="scroll-table" :data="scrollingTableData" />

    </div>
</template>

<script>
import groundLevelData from '@/mixins/groundLevelData';
import ScrollingTable from '@/components/ScrollingTable';
import * as d3 from 'd3';

export default {
    name: 'station-ground-level-table',
    mixins: [groundLevelData],
    components: {
        ScrollingTable,
    },
    methods: {
        getColor(val, max, min) {
            // Define the colors
            const low = [245, 252, 255];
            const high = [111, 145, 164];
            const result = [255, 255, 255];

            // Check if a value is the same as max
            if (val === max) {
                return `rgb(${high[0]}, ${high[1]}, ${high[2]})`;
            }

            // Check if the value is the same as min
            if (val === min) {
                return `rgb(${low[0]}, ${low[1]}, ${low[2]})`;
            }

            // Calculate the color for the value
            for (let i = 0; i < result.length; i++) { // eslint-disable-line no-plusplus
                result[i] = Math.round(low[i] + ((val - min) * ((high[i] - low[i]) / (max - min))));
            }

            // Return the result
            return `rgb(${result[0]}, ${result[1]}, ${result[2]})`;
        },
    },
    computed: {
        scrollingTableData() {
            const tableData = this.tableData || [];

            // colorize cells
            for (let r = 1, numRows = tableData.length; r < numRows; r += 1) {
                const row = tableData[r];
                const vals = row.slice(1).map(e => e.text);
                const min = d3.min(vals);
                const max = d3.max(vals);
                row.forEach((col, c) => {
                    if (c === 0) return;
                    const val = col.text;
                    const color = this.getColor(val, max, min);
                    tableData[r][c].color = color;
                });
            }

            return tableData;
        },
    },
};
</script>

<style lang="scss">
.groundwater-level-table.table-wrap {
    overflow: auto;

    .scroll-table {
        height: calc(100vh - 220px);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/charts/StationGroundLevelTable.vue